import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials'
})
export class InitialsPipe implements PipeTransform {

  transform(value: string): string {
    if (!value?.length) return '';
    return value.split(' ').map(segment => segment.charAt(0).toUpperCase()).slice(0, 2).join('');
  }

}
